import css from "./css";
import greeting from "./greeting";
import message from "./message";
import time from "./time";
import weather from "./weather";
import luminaverse from "./luminaverse";


export const widgetConfigs = [
  luminaverse,
  weather,
  time,
  message,
  greeting,
  css,
];
